import { render } from "./TheFooter.vue?vue&type=template&id=1bf3886d&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=1bf3886d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1bf3886d"

export default script